<template>
  <table class="Diff">
    <thead v-if="keys.length">
      <tr>
        <th v-for="key in keys" :key="key">
          {{ key }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="doCompactMatched" class="matched">
        <DiffCell
          v-for="({ value }, key) in diffTreeMatching"
          :key="key"
          theme="info"
          type="word"
          :value="value" />
      </tr>
      <DiffRow
        v-for="(diff, key) in diffTreeVisible"
        :key="key"
        :diff="diff"
        :diffKey="key"
        @accept="$emit('accept', $event)"
        @reject="$emit('reject', $event)" />
    </tbody>
  </table>
</template>

<script>
import DiffCell from './DiffCell'
import DiffRow from './DiffRow'
import { filter } from 'rambda'

export default {
  components: {
    DiffCell,
    DiffRow,
  },
  props: {
    diffTree: { type: Object, required: true },
    doCompactMatched: { type: Boolean, default: false },
    keys: { type: Array, default: () => [] },
  },
  computed: {
    diffTreeVisible() {
      if (!this.doCompactMatched) return this.diffTree

      return filter(
        ({ value, valueOriginal }) => value !== valueOriginal,
        this.diffTree,
      )
    },
    diffTreeMatching() {
      return filter(
        ({ value, valueOriginal }) => value === valueOriginal,
        this.diffTree,
      )
    },
  },
}
</script>

<style lang="scss">
.Diff {
  font-family: $monotype;
  margin-bottom: $u;

  thead th {
    padding: $uh;
    text-align: left;
  }

  tr.matched {
    .DiffCell {
      display: inline-block;
    }
  }
}
</style>
